export default __webpack_public_path__ + "a71870d47f51890a65be3a7eba30018e.svg";